import jsPDF from 'jspdf'
 window.jpdf = jsPDF